module.exports = __webpack_public_path__ + "static/img/D4104.f694eb27.png";